export class ChannelCategory {
    id: string;
    vesselId: string;
    rowId: number;
    category: string;
    excelId: string;
}

export function getExistingRowIds(categories: ChannelCategory[]) {
    return categories.map((category: ChannelCategory) => category.rowId);
}

export const MAX_CHANNEL_CATEGORIES = 10;
